// utils/apiUtils.js

const hash_key = 'H6YY4nq0fuRnThclxRIkNmbwsDWXuZcO';
//const host =  'http://cityka.backend';
const host =  'https://game2.eek.ee';
//const host =  'https://ucgame.local';


/**
 * Fetch data from a given endpoint.
 * @param {string} url - The API endpoint.
 * @returns {Promise<any>} - The response data.
 */
export const fetchData = async (url) => {
    try {
        url = host + url;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + hash_key,
            },
            credentials: 'include', // Include credentials like cookies
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


/**
 * Post data to given endpoint.
 * @param {string} url - The API endpoint.
 * @param data
 * @returns {Promise<any>} - The response data.
 */
export const postData = async (url, data) => {
    try {
        url = host + url;

        console.log("Sending Data:", data); // Debugging
        console.log("Serialized Data:", JSON.stringify(data)); // Ensure JSON is correct

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                //'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + hash_key,
            },
            credentials: 'include', // Include credentials like cookies
            body: data, //JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Server Response:", result);

        return result;
    } catch (error) {
        console.error('Error posting data:', error);
        throw error;
    }
};
